import consola from 'consola'
import { useSafeArea } from '@shared/lib'

/**
 * Plugin для инициализации системы safe area при запуске приложения
 *
 * Нативная часть @capacitor-community/safe-area v7 включается сама при старте
 * приложения (конфиг — в capacitor.config.ts); JS-метода enable() у v7 больше
 * нет, прежний вызов кидал исключение на каждом запуске. Здесь остаётся только
 * инициализация JS-слоя: замер insets и подписка на повороты экрана.
 *
 * Критично для нативных приложений (iOS/Android)
 */
export default defineNuxtPlugin({
  name: 'safe-area-init',
  enforce: 'pre', // Запускаем рано

  async setup() {
    consola.log('🚀 [SafeArea] Инициализация safe area system')

    const safeArea = useSafeArea()

    try {
      await safeArea.initialize()

      consola.log('✅ [SafeArea] Система инициализирована', {
        top: safeArea.safeTop.value,
        bottom: safeArea.safeBottom.value,
        left: safeArea.safeLeft.value,
        right: safeArea.safeRight.value,
        platform: safeArea.platform.value,
      })
    } catch (error) {
      consola.error('❌ [SafeArea] Ошибка инициализации:', error)
    }
  },
})
